import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const isoDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function monthOf(offset = 0) {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(1);
  d.setMonth(d.getMonth() + offset);
  return d;
}

const WD = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function MonthGrid({ monthDate, onPrev, onNext, onToday, renderDay, getCellProps, testid = "month-grid" }) {
  const first = new Date(monthDate);
  const startOffset = (first.getDay() + 6) % 7; // Monday-first
  const gridStart = new Date(first);
  gridStart.setDate(1 - startOffset);
  const daysInMonth = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
  const weeks = Math.ceil((startOffset + daysInMonth) / 7);
  const todayIso = isoDate(new Date());
  const monthLabel = first.toLocaleDateString("en", { month: "long", year: "numeric" });
  const cells = Array.from({ length: weeks * 7 }, (_, i) => {
    const d = new Date(gridStart);
    d.setDate(gridStart.getDate() + i);
    return d;
  });

  return (
    <div data-testid={testid}>
      <div className="flex items-center gap-2 mb-4">
        <Button variant="outline" size="icon" className="rounded-full h-9 w-9" onClick={onPrev} data-testid="month-prev"><ChevronLeft className="w-4 h-4" /></Button>
        <Button variant="outline" size="sm" className="rounded-full" onClick={onToday} data-testid="month-today">This month</Button>
        <Button variant="outline" size="icon" className="rounded-full h-9 w-9" onClick={onNext} data-testid="month-next"><ChevronRight className="w-4 h-4" /></Button>
        <span className="text-sm font-semibold ml-2">{monthLabel}</span>
      </div>
      <div className="rounded-2xl border border-[#E8E6E1] bg-white overflow-hidden">
        <div className="grid grid-cols-7">
          {WD.map((w) => (
            <div key={w} className="text-center py-2.5 bg-[#FDFBF7] border-b border-[#F0EFEB] text-[10px] uppercase tracking-wide text-[#787672] font-semibold">{w}</div>
          ))}
          {cells.map((d, i) => {
            const ds = isoDate(d);
            const inMonth = d.getMonth() === first.getMonth();
            const today = ds === todayIso;
            const cp = (getCellProps && getCellProps(ds, inMonth)) || {};
            const { className: cpClass, ...cpRest } = cp;
            return (
              <div key={ds} data-testid={`day-cell-${ds}`} {...cpRest}
                className={`min-h-[108px] border-b border-[#F0EFEB] p-1.5 transition-colors ${i % 7 !== 0 ? "border-l" : ""} ${!inMonth ? "bg-[#FBFAF7]" : ""} ${cpClass || ""}`}>
                <div className={`text-[11px] font-semibold mb-1 ${today ? "inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#0EA5A5] text-white" : inMonth ? "text-[#2C3531]" : "text-[#C4C1BA]"}`}>{d.getDate()}</div>
                <div className="space-y-1">{inMonth && renderDay(ds)}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
